export default __webpack_public_path__ + "static/media/logo-ceppro.f75816f9.svg";